// extracted by mini-css-extract-plugin
export default {"page":"ContactPage_page__sOiSF"};